import { AutoReportSideModal } from 'src/components';
import { AutoReportContext } from 'src/context';
import { useAutoReportContext } from './useAutoReportContext';

type AutoReportProviderProps = {
  children: React.ReactNode;
  isShowToggleActivated?: boolean;
  onClose?: () => void;
  productName?: string;
  showSideModalParent?: boolean;
};

export const AutoReportProvider = ({
  children,
  isShowToggleActivated,
  onClose,
  productName,
  showSideModalParent,
}: AutoReportProviderProps) => {
  const {
    showSideModal,
    selectedProduct,
    showCancelReportModal,
    isEditConfig,
    forceEnableField,
    isActive,
    isErrorMessageVisible,
    clickFrom,
    onDisable,
    onShowSideModal,
    onCloseSideModal,
    onShowDisableReportModal,
    onCloseDisableReportModal,
    setIsActive,
    setIsErrorMessageVisible,
    onToggleActivation,
    onShowDisableReportModalFromProduct,
  } = useAutoReportContext({ productName, showSideModalParent });

  return (
    <AutoReportContext.Provider
      value={{
        showSideModal,
        selectedProduct,
        showCancelReportModal,
        isEditConfig,
        forceEnableField,
        isActive,
        isErrorMessageVisible,
        clickFrom,
        setIsErrorMessageVisible,
        onDisable,
        onShowSideModal,
        onCloseSideModal,
        onShowDisableReportModal,
        onCloseDisableReportModal,
        setIsActive,
        onToggleActivation,
        onShowDisableReportModalFromProduct,
      }}
    >
      {children}
      <AutoReportSideModal
        isShowToggleActivated={isShowToggleActivated}
        onParentClose={onClose}
      />
    </AutoReportContext.Provider>
  );
};
